var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvancementsInEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.17,
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    fill: "#DC2418"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_433_31)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4383 20.1147C35.2861 19.4365 36.4653 19.388 37.3604 19.9694L37.5617 20.1147L44.749 25.8645C45.4606 26.4338 45.9046 27.2665 45.9863 28.1655L46 28.4674V32.6667H49.3333C51.0907 32.6667 52.5303 34.0264 52.6575 35.7512L52.6667 36V49.1667C52.6667 50.1117 51.9516 50.8897 51.0331 50.9892L50.8333 51H21.1667C20.2217 51 19.4436 50.285 19.3441 49.3664L19.3333 49.1667V36C19.3333 34.2427 20.6931 32.8031 22.4179 32.6758L22.6667 32.6667H26V28.4674C26 27.5561 26.3728 26.6892 27.0238 26.0638L27.251 25.8645L34.4383 20.1147ZM36 23.1341L29.3333 28.4674V47.6663H42.6667V28.4674L36 23.1341ZM49.3333 36H46V47.6667H49.3333V36ZM26 36H22.6667V47.6667H26V36ZM36 29.3333C38.7615 29.3333 41 31.5719 41 34.3333C41 37.0948 38.7615 39.3333 36 39.3333C33.2385 39.3333 31 37.0948 31 34.3333C31 31.5719 33.2385 29.3333 36 29.3333ZM36 32.6667C35.0795 32.6667 34.3333 33.4128 34.3333 34.3333C34.3333 35.2538 35.0795 36 36 36C36.9205 36 37.6667 35.2538 37.6667 34.3333C37.6667 33.4128 36.9205 32.6667 36 32.6667Z",
    fill: "#DC2418"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_433_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancementsInEducation);
export default __webpack_public_path__ + "static/media/advancementsInEducation.64f248f65da9855aaa4f424ec90ef615.svg";
export { ForwardRef as ReactComponent };